import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import FancyTitle from './fancy-title';
import { loadExternalScript } from '../lib/utils';

export default function PipedriveForm({
  title, subtitle, text, tag = 'h2', onlyFirstImage = false,
}) {
  React.useEffect(() => {
    loadExternalScript('https://webforms.pipedrive.com/f/loader', { defer: true, in: 'head', force: true });
  }, []);

  const formID = '1rq7nu1iuL8GqUg2CxYDsAd24yA6hpZHaH3VrPWMEc5Iu6PjKdqT5ddGThTRuS2n9';

  return (
    <>

      <FancyTitle
        text={title}
        subtitle={subtitle}
        textAlign="text-center lg:text-center"
        className="mx-auto"
        marginBottom="mb-10"
        tag={tag}
      />

      <div className="flex flex-wrap justify-center text-center mb-10 gap-12">
        <div>
          <div>
            <StaticImage
              alt="Jan Laußmann - Co-Founder & CEO"
              className="h-52 w-52 rounded-full mb-4"
              src="./../assets/jan_laußmann.jpg"
              width={400}
              height={400}
            />
          </div>
          Jan Laußmann
          <br />
          Co-Founder & CEO
        </div>
        {!onlyFirstImage && (
          <div>
            <div>
              <StaticImage
                alt="Marco König - Consultant"
                className="h-52 w-52 rounded-full mb-4"
                src="./../assets/marco_koenig.jpg"
                width={400}
                height={400}
              />
            </div>
            Marco König
            <br />
            Consultant
          </div>
        )}
      </div>

      <div className="text-center mb-20 mx-auto w-full max-w-5xl">
        <p dangerouslySetInnerHTML={{ __html: text }} />
      </div>
      <div id="contact-form">
        <div
          className="pipedriveWebForms"
          data-pd-webforms={`https://webforms.pipedrive.com/f/${formID}`}
        />
      </div>
    </>
  );
}
